import { PublicClientApplication } from "@azure/msal-browser";

// Use 'organizations' as a safe default for multi-tenant apps during local dev.
const tenantId = process.env.REACT_APP_AAD_TENANT_ID || "organizations";
const clientId = process.env.REACT_APP_AAD_CLIENT_ID || "";

// Helpful hint if tenant isn't explicitly set for single-tenant apps
if (tenantId === "organizations") {
  // eslint-disable-next-line no-console
  console.warn(
    "MSAL: Using 'organizations' authority. For single-tenant apps, set REACT_APP_AAD_TENANT_ID to your tenant GUID."
  );
}

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // Helpful for debugging endpoint resolution issues
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level >= 2) console.warn("MSAL:", message);
      },
      piiLoggingEnabled: false,
      logLevel: 2,
    },
  },
});

export function getActiveAccount() {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length ? accounts[0] : null;
}

export async function login() {
  if (!clientId) {
    throw new Error(
      "MSAL clientId not set. Define REACT_APP_AAD_CLIENT_ID in your environment."
    );
  }
  await msalInstance.loginRedirect({
    scopes: ["openid", "profile", "email"],
  });
}

export async function logout() {
  const account = getActiveAccount();
  
  // Clear agent conversation data to prevent cross-user leakage
  localStorage.removeItem('agentThreadId');
  localStorage.removeItem('agentChatHistory');
  console.log('[Logout] Cleared agent conversation data');
  
  await msalInstance.logoutRedirect({ account });
}
